/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=3213e2be"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3213e2be&lang=less"

import exportComponent from "/Users/neo/Desktop/SynologyDrive/2.gitee/NeoCharming/zangyu/fenci/node_modules/.pnpm/vue-loader@17.0.1_vue@3.2.47+webpack@5.75.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__